import { render, staticRenderFns } from "./vipManagement.vue?vue&type=template&id=df91c654&scoped=true"
import script from "./vipManagement.vue?vue&type=script&lang=ts"
export * from "./vipManagement.vue?vue&type=script&lang=ts"
import style0 from "./vipManagement.vue?vue&type=style&index=0&id=df91c654&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df91c654",
  null
  
)

export default component.exports